<template>
  <div class="calculator__items">
    <CalcComment
      v-if="resultPageSuccess"
      class="mt-4"
      style="margin-bottom: 40px;"
    >
      <template #icon>
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
        >
          <path
            d="M11.5625 13.75V8.75H9.0625V10H10.3125V13.75H8.4375V15H13.4375V13.75H11.5625ZM10.9375 5C10.7521 5 10.5708 5.05498 10.4167 5.158C10.2625 5.26101 10.1423 5.40743 10.0714 5.57873C10.0004 5.75004 9.98184 5.93854 10.018 6.1204C10.0542 6.30225 10.1435 6.4693 10.2746 6.60041C10.4057 6.73152 10.5727 6.82081 10.7546 6.85699C10.9365 6.89316 11.125 6.87459 11.2963 6.80364C11.4676 6.73268 11.614 6.61252 11.717 6.45835C11.82 6.30418 11.875 6.12292 11.875 5.9375C11.875 5.68886 11.7762 5.4504 11.6004 5.27459C11.4246 5.09877 11.1861 5 10.9375 5Z"
            fill="#50616F"
          />
          <path
            d="M10.9375 18.75C9.20692 18.75 7.51519 18.2368 6.07626 17.2754C4.63733 16.3139 3.51582 14.9473 2.85356 13.3485C2.19129 11.7496 2.01801 9.9903 2.35563 8.29296C2.69325 6.59563 3.52661 5.03653 4.75032 3.81282C5.97403 2.58911 7.53313 1.75575 9.23046 1.41813C10.9278 1.08051 12.6871 1.25379 14.286 1.91606C15.8848 2.57832 17.2514 3.69983 18.2129 5.13876C19.1743 6.57769 19.6875 8.26942 19.6875 10C19.6875 12.3206 18.7656 14.5462 17.1247 16.1872C15.4837 17.8281 13.2581 18.75 10.9375 18.75ZM10.9375 2.5C9.45414 2.5 8.0041 2.93987 6.77073 3.76398C5.53736 4.58809 4.57606 5.75943 4.00841 7.12988C3.44075 8.50032 3.29223 10.0083 3.58161 11.4632C3.871 12.918 4.58531 14.2544 5.6342 15.3033C6.6831 16.3522 8.01947 17.0665 9.47433 17.3559C10.9292 17.6453 12.4372 17.4968 13.8076 16.9291C15.1781 16.3614 16.3494 15.4001 17.1735 14.1668C17.9976 12.9334 18.4375 11.4834 18.4375 10C18.4375 8.01088 17.6473 6.10323 16.2408 4.6967C14.8343 3.29018 12.9266 2.5 10.9375 2.5Z"
            fill="#50616F"
          />
        </svg>
      </template>
      <template #title>
        Электронная накладная оплачена
      </template>
      Вы можете вернуть деньги в случае, если вы не совершили отправление, позвонив в контакт центр по номеру: +0000000000000
    </CalcComment>
    <CalcCommentError
      v-if="resultPageFail && resultFailText"
      class="mt-4"
      style="margin-bottom: 40px;"
    >
      <template #icon>
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
        >
          <path
            d="M11.5625 13.75V8.75H9.0625V10H10.3125V13.75H8.4375V15H13.4375V13.75H11.5625ZM10.9375 5C10.7521 5 10.5708 5.05498 10.4167 5.158C10.2625 5.26101 10.1423 5.40743 10.0714 5.57873C10.0004 5.75004 9.98184 5.93854 10.018 6.1204C10.0542 6.30225 10.1435 6.4693 10.2746 6.60041C10.4057 6.73152 10.5727 6.82081 10.7546 6.85699C10.9365 6.89316 11.125 6.87459 11.2963 6.80364C11.4676 6.73268 11.614 6.61252 11.717 6.45835C11.82 6.30418 11.875 6.12292 11.875 5.9375C11.875 5.68886 11.7762 5.4504 11.6004 5.27459C11.4246 5.09877 11.1861 5 10.9375 5Z"
            fill="#50616F"
          />
          <path
            d="M10.9375 18.75C9.20692 18.75 7.51519 18.2368 6.07626 17.2754C4.63733 16.3139 3.51582 14.9473 2.85356 13.3485C2.19129 11.7496 2.01801 9.9903 2.35563 8.29296C2.69325 6.59563 3.52661 5.03653 4.75032 3.81282C5.97403 2.58911 7.53313 1.75575 9.23046 1.41813C10.9278 1.08051 12.6871 1.25379 14.286 1.91606C15.8848 2.57832 17.2514 3.69983 18.2129 5.13876C19.1743 6.57769 19.6875 8.26942 19.6875 10C19.6875 12.3206 18.7656 14.5462 17.1247 16.1872C15.4837 17.8281 13.2581 18.75 10.9375 18.75ZM10.9375 2.5C9.45414 2.5 8.0041 2.93987 6.77073 3.76398C5.53736 4.58809 4.57606 5.75943 4.00841 7.12988C3.44075 8.50032 3.29223 10.0083 3.58161 11.4632C3.871 12.918 4.58531 14.2544 5.6342 15.3033C6.6831 16.3522 8.01947 17.0665 9.47433 17.3559C10.9292 17.6453 12.4372 17.4968 13.8076 16.9291C15.1781 16.3614 16.3494 15.4001 17.1735 14.1668C17.9976 12.9334 18.4375 11.4834 18.4375 10C18.4375 8.01088 17.6473 6.10323 16.2408 4.6967C14.8343 3.29018 12.9266 2.5 10.9375 2.5Z"
            fill="#50616F"
          />
        </svg>
      </template>
      <template #title>
        Ошибка при оплате!
      </template>
      {{ resultFailText }}
    </CalcCommentError>
    <div class="calculator__item calculator__item_active">
      <template v-if="selectedSenderODP && !isCourierFence">
        <div class="calculator__cols">
          <div class="calculator__col">
            <div class="calc-6th__odp-desc">
              <div class="calculator-field__label mb-3">
                Отнесите посылку в отделение Boxberry по адресу:
              </div>
              <ul class="calc-6th__odp-desc__list">
                <li>
                  <svg
                    width="20px"
                    height="20px"
                  >
                    <use xlink:href="#point" />
                  </svg>
                  {{ orderPIP.sender.pointAddress }}
                </li>
                <li>
                  <svg
                    width="20px"
                    height="20px"
                  >
                    <use xlink:href="#tel" />
                  </svg>
                  {{ orderPIP.sender.pointPhone }}
                </li>
                <li>
                  <svg
                    width="20px"
                    height="20px"
                  >
                    <use xlink:href="#clock2" />
                  </svg>
                  {{ orderPIP.sender.pointScheduleShort }}
                </li>
              </ul>
            </div>
            <SlickGallery
              v-if="orderPIP.sender && orderPIP.sender.pointPhotos && orderPIP.sender.pointPhotos.length"
              :odp="{photos: orderPIP.sender.pointPhotos}"
              class="calc-6th__gallery"
            />
          </div>
          <div class="calculator__col calculator__col_order-num">
            <div class="calculator-field__label mb-2 mb-lg-3">
              Номер вашего отправления, покажите его в&nbsp;отделении:
            </div>
            <div
              class="field-input mb-4"
            >
              <label @click="copyToClipboard">
                <input
                  class="field-input__inner field-input__inner_order-num"
                  placeholder="Номер отправления"
                  :value="order_num"
                  readonly
                  type="text"
                  autocomplete="new-password"
                  style="cursor: pointer;"
                >
              </label>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M20.55 11.025L15.975 6.45C15.75 6.15 15.375 6 15 6H9C8.175 6 7.5 6.675 7.5 7.5V21C7.5 21.825 8.175 22.5 9 22.5H19.5C20.325 22.5 21 21.825 21 21V12.075C21 11.7 20.85 11.325 20.55 11.025ZM15 7.5L19.425 12H15V7.5ZM9 21V7.5H13.5V12C13.5 12.825 14.175 13.5 15 13.5H19.5V21H9Z"
                  fill="#50616F"
                />
                <path
                  d="M4.5 13.5H3V3C3 2.175 3.675 1.5 4.5 1.5H15V3H4.5V13.5Z"
                  fill="#50616F"
                />
              </svg>
            </div>

            <CalcComment>
              <template #icon>
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                >
                  <path
                    d="M11.5625 13.75V8.75H9.0625V10H10.3125V13.75H8.4375V15H13.4375V13.75H11.5625ZM10.9375 5C10.7521 5 10.5708 5.05498 10.4167 5.158C10.2625 5.26101 10.1423 5.40743 10.0714 5.57873C10.0004 5.75004 9.98184 5.93854 10.018 6.1204C10.0542 6.30225 10.1435 6.4693 10.2746 6.60041C10.4057 6.73152 10.5727 6.82081 10.7546 6.85699C10.9365 6.89316 11.125 6.87459 11.2963 6.80364C11.4676 6.73268 11.614 6.61252 11.717 6.45835C11.82 6.30418 11.875 6.12292 11.875 5.9375C11.875 5.68886 11.7762 5.4504 11.6004 5.27459C11.4246 5.09877 11.1861 5 10.9375 5Z"
                    fill="#50616F"
                  />
                  <path
                    d="M10.9375 18.75C9.20692 18.75 7.51519 18.2368 6.07626 17.2754C4.63733 16.3139 3.51582 14.9473 2.85356 13.3485C2.19129 11.7496 2.01801 9.9903 2.35563 8.29296C2.69325 6.59563 3.52661 5.03653 4.75032 3.81282C5.97403 2.58911 7.53313 1.75575 9.23046 1.41813C10.9278 1.08051 12.6871 1.25379 14.286 1.91606C15.8848 2.57832 17.2514 3.69983 18.2129 5.13876C19.1743 6.57769 19.6875 8.26942 19.6875 10C19.6875 12.3206 18.7656 14.5462 17.1247 16.1872C15.4837 17.8281 13.2581 18.75 10.9375 18.75ZM10.9375 2.5C9.45414 2.5 8.0041 2.93987 6.77073 3.76398C5.53736 4.58809 4.57606 5.75943 4.00841 7.12988C3.44075 8.50032 3.29223 10.0083 3.58161 11.4632C3.871 12.918 4.58531 14.2544 5.6342 15.3033C6.6831 16.3522 8.01947 17.0665 9.47433 17.3559C10.9292 17.6453 12.4372 17.4968 13.8076 16.9291C15.1781 16.3614 16.3494 15.4001 17.1735 14.1668C17.9976 12.9334 18.4375 11.4834 18.4375 10C18.4375 8.01088 17.6473 6.10323 16.2408 4.6967C14.8343 3.29018 12.9266 2.5 10.9375 2.5Z"
                    fill="#50616F"
                  />
                </svg>
              </template>
              Отправка происходит при наличии паспорта
            </CalcComment>
            <GiftCalcCard
              v-if="!isMobile"
              class="calc-6th__gift-card"
            />
          </div>
        </div>
      </template>
      <template v-if="isCourierFence">
        <div class="calculator__cols calculator__cols_courier">
          <div class="calculator__col">
            <div class="calculator-field__label mb-3">
              Пожалуйста, дождитесь звонка от нашего сотрудника для согласовывания времени курьерского забора.
            </div>
            <div class="calc-6th__text">
              Если вы создали накладную в рабочий день до 16:00, то мы перезвоним в этот же день. Курьер сможет приехать не ранее, чем на следующий день. Если накладная сделана после 16:00 или в выходной день, то ожидайте звонка на следующий рабочий день. Курьер приедет за вашей посылкой через день.
            </div>
            <div class="calculator-field__label mb-2 mb-lg-3">
              Номер вашего отправления, покажите его в&nbsp;отделении:
            </div>
            <div
              class="field-input mb-4"
            >
              <label @click="copyToClipboard">
                <input
                  class="field-input__inner field-input__inner_order-num"
                  placeholder="Номер отправления"
                  :value="order_num"
                  readonly
                  type="text"
                  autocomplete="new-password"
                  style="cursor: pointer;"
                >
              </label>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M20.55 11.025L15.975 6.45C15.75 6.15 15.375 6 15 6H9C8.175 6 7.5 6.675 7.5 7.5V21C7.5 21.825 8.175 22.5 9 22.5H19.5C20.325 22.5 21 21.825 21 21V12.075C21 11.7 20.85 11.325 20.55 11.025ZM15 7.5L19.425 12H15V7.5ZM9 21V7.5H13.5V12C13.5 12.825 14.175 13.5 15 13.5H19.5V21H9Z"
                  fill="#50616F"
                />
                <path
                  d="M4.5 13.5H3V3C3 2.175 3.675 1.5 4.5 1.5H15V3H4.5V13.5Z"
                  fill="#50616F"
                />
              </svg>
            </div>
            <GiftCalcCard
              v-if="!isMobile"
              class="calc-6th__gift-card"
            />
          </div>
          <div class="calculator__col">
            <div class="calc-6th__mobile-app-links">
              <div class="calc-6th__mobile-app-links__inner">
                <h3 class="mobile-app-links__title">
                  Отслеживайте доставку и&nbsp;оформляйте посылки
                  <span style="display: inline-block;">в&nbsp;новом мобильном приложении Boxberry</span>
                </h3>
                <ul class="mobile-app-links__items">
                  <li class="mobile-app-links__item">
                    <a
                      :href="MOBILE_STORES.GOOGLE_PLAY + '?click_id={futter}'"
                      class="mobile-app-links__item__link mobile-app-links__item__link_google"
                      target="_blank"
                      rel="noopener"
                    />
                  </li>
                  <li class="mobile-app-links__item">
                    <a
                      :href="MOBILE_STORES.APP_STORE + '?click_id={futter}'"
                      class="mobile-app-links__item__link mobile-app-links__item__link_store"
                      target="_blank"
                      rel="noopener"
                    />
                  </li>
                  <li class="mobile-app-links__item">
                    <a
                      :href="MOBILE_STORES.APP_GALLERY"
                      class="mobile-app-links__item__link mobile-app-links__item__link_gallery"
                      target="_blank"
                      rel="noopener"
                    />
                  </li>
                </ul>
                <div class="mobile-app-links__text">
                  Наведите камеру и&nbsp;скачайте <br>бесплатное приложение <br><strong>Boxberry</strong>
                </div>
                <div class="mobile-app-links__content">
                  <div class="mobile-app-links__qr-code" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="!selectedSenderODP && !isCourierFence">
        <div class="calculator__cols calculator__cols_courier">
          <div class="calculator__col">
            <div class="calculator-field__label mb-3">
              В скором времени с вами свяжется наш специалист для уточнения времени курьерской доставки
            </div>
            <div class="calculator-field__label mb-2 mb-lg-3">
              Номер вашего отправления, покажите его в&nbsp;отделении:
            </div>
            <div
              class="field-input mb-4"
            >
              <label @click="copyToClipboard">
                <input
                  class="field-input__inner field-input__inner_order-num"
                  placeholder="Номер отправления"
                  :value="order_num"
                  readonly
                  type="text"
                  autocomplete="new-password"
                  style="cursor: pointer;"
                >
              </label>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M20.55 11.025L15.975 6.45C15.75 6.15 15.375 6 15 6H9C8.175 6 7.5 6.675 7.5 7.5V21C7.5 21.825 8.175 22.5 9 22.5H19.5C20.325 22.5 21 21.825 21 21V12.075C21 11.7 20.85 11.325 20.55 11.025ZM15 7.5L19.425 12H15V7.5ZM9 21V7.5H13.5V12C13.5 12.825 14.175 13.5 15 13.5H19.5V21H9Z"
                  fill="#50616F"
                />
                <path
                  d="M4.5 13.5H3V3C3 2.175 3.675 1.5 4.5 1.5H15V3H4.5V13.5Z"
                  fill="#50616F"
                />
              </svg>
            </div>
          </div>
          <div class="calculator__col">
            <div class="calc-6th__mobile-app-links">
              <div class="calc-6th__mobile-app-links__inner">
                <h3 class="mobile-app-links__title">
                  Отслеживайте доставку и&nbsp;оформляйте посылки
                  <span style="display: inline-block;">в&nbsp;новом мобильном приложении Boxberry</span>
                </h3>
                <ul class="mobile-app-links__items">
                  <li class="mobile-app-links__item">
                    <a
                      :href="MOBILE_STORES.GOOGLE_PLAY + '?click_id={futter}'"
                      class="mobile-app-links__item__link mobile-app-links__item__link_google"
                      target="_blank"
                      rel="noopener"
                    />
                  </li>
                  <li class="mobile-app-links__item">
                    <a
                      :href="MOBILE_STORES.APP_STORE + '?click_id={futter}'"
                      class="mobile-app-links__item__link mobile-app-links__item__link_store"
                      target="_blank"
                      rel="noopener"
                    />
                  </li>
                  <li class="mobile-app-links__item">
                    <a
                      :href="MOBILE_STORES.APP_GALLERY"
                      class="mobile-app-links__item__link mobile-app-links__item__link_gallery"
                      target="_blank"
                      rel="noopener"
                    />
                  </li>
                </ul>
                <div class="mobile-app-links__text">
                  Наведите камеру и&nbsp;скачайте <br>бесплатное приложение <br><strong>Boxberry</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div
        v-if="orderPIP.sender.point && !isCourierFence"
        id="calculatorMapPreview"
        class="calc-6th__calculator-map-preview"
      >
        <CalculatorSelectedOdp :point="selectedSenderODP" />
      </div>
      <div
        v-if="isPaymentRfRf"
        class="calc-6th__email-wrap"
      >
        <div
          class="calculator-form__field calculator-form__field_input calculator-form__field_full-width"
        >
          <label class="calculator-form__label">Укажите e-mail для отправки чека: </label>
          <span
            class="field-input"
            :class="{'field-item__error': validations.emailPayment.$error}"
          >
            <label>
              <input
                id="sender-email"
                :value="emailPayment"
                class="field-input__inner"
                :placeholder="$t('calc.form.el-pochta')"
                required=""
                type="email"
                autocomplete="new-password"
                @input="($event) => $emit('change-email', $event.target.value)"
                @blur="validations.emailPayment.$touch()"
              >
            </label>
            <span
              v-if="!validations.emailPayment.required"
              class="field__error"
            >
              Обязательно для заполнения
            </span>

            <span
              v-else-if="!validations.emailPayment.validFormat"
              class="field__error"
            >
              Введите e-mail в верном формате
            </span>

            <span
              v-else-if="validations.emailPayment.$error && !emailPayment.length"
              class="field__error_inv"
            >
              Обязательно для заполнения
            </span>

          </span>
        </div>
        <button
          type="button"
          class="calculator__button calculator__button_payment"
          :class="{'calculator__button_loading': isLoading}"
          style="min-width: 252px;"
          @click="onPaymentClick"
        >
          Оплатить
        </button>
      </div>
      <div
        v-if="isMobile"
        class="calc-6th__gift-card-wrap"
      >
        <GiftCalcCard class="calc-6th__gift-card"/>
      </div>
    </div>
    <CalcNavDesktop
      v-if="!isMobile"
      class="calc-6th__nav-desktop"
      :is-loading="isLoading"
    >
      <template #content>
        <a
          class="calculator__button calculator__button_back-step"
          :class="{'calculator__button_loading': isLoading}"
          @click="onRestart"
        >
          <span>
            Оформить еще одну посылку
          </span>
        </a>
        <CalcComment
          class="calc-6th__comment"
          success
        >
          <template #icon>
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
            >
              <path
                d="M11.5625 13.75V8.75H9.0625V10H10.3125V13.75H8.4375V15H13.4375V13.75H11.5625ZM10.9375 5C10.7521 5 10.5708 5.05498 10.4167 5.158C10.2625 5.26101 10.1423 5.40743 10.0714 5.57873C10.0004 5.75004 9.98184 5.93854 10.018 6.1204C10.0542 6.30225 10.1435 6.4693 10.2746 6.60041C10.4057 6.73152 10.5727 6.82081 10.7546 6.85699C10.9365 6.89316 11.125 6.87459 11.2963 6.80364C11.4676 6.73268 11.614 6.61252 11.717 6.45835C11.82 6.30418 11.875 6.12292 11.875 5.9375C11.875 5.68886 11.7762 5.4504 11.6004 5.27459C11.4246 5.09877 11.1861 5 10.9375 5Z"
                fill="#50616F"
              />
              <path
                d="M10.9375 18.75C9.20692 18.75 7.51519 18.2368 6.07626 17.2754C4.63733 16.3139 3.51582 14.9473 2.85356 13.3485C2.19129 11.7496 2.01801 9.9903 2.35563 8.29296C2.69325 6.59563 3.52661 5.03653 4.75032 3.81282C5.97403 2.58911 7.53313 1.75575 9.23046 1.41813C10.9278 1.08051 12.6871 1.25379 14.286 1.91606C15.8848 2.57832 17.2514 3.69983 18.2129 5.13876C19.1743 6.57769 19.6875 8.26942 19.6875 10C19.6875 12.3206 18.7656 14.5462 17.1247 16.1872C15.4837 17.8281 13.2581 18.75 10.9375 18.75ZM10.9375 2.5C9.45414 2.5 8.0041 2.93987 6.77073 3.76398C5.53736 4.58809 4.57606 5.75943 4.00841 7.12988C3.44075 8.50032 3.29223 10.0083 3.58161 11.4632C3.871 12.918 4.58531 14.2544 5.6342 15.3033C6.6831 16.3522 8.01947 17.0665 9.47433 17.3559C10.9292 17.6453 12.4372 17.4968 13.8076 16.9291C15.1781 16.3614 16.3494 15.4001 17.1735 14.1668C17.9976 12.9334 18.4375 11.4834 18.4375 10C18.4375 8.01088 17.6473 6.10323 16.2408 4.6967C14.8343 3.29018 12.9266 2.5 10.9375 2.5Z"
                fill="#50616F"
              />
            </svg>
          </template>
          <template #title>
            Удобнее и быстрее оформить в личном кабинете
          </template>
        </CalcComment>
        <a
          class="calculator__button calculator__button_to-lk"
          :href="`https://lk.boxberry.ru/${UTMTags}`"
          rel="noopener"
        >Войти в&nbsp;личный кабинет</a>
      </template>
    </CalcNavDesktop>
    <CalcNavMobile
      v-else
      class="calc-6th__nav-mobile"
      :is-loading="isLoading"
    >
      <template #content>
        <div class="calc-6th__nav-mobile__content">
          <CalcComment
            class="mb-2"
            success
          >
            <template #icon>
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
              >
                <path
                  d="M11.5625 13.75V8.75H9.0625V10H10.3125V13.75H8.4375V15H13.4375V13.75H11.5625ZM10.9375 5C10.7521 5 10.5708 5.05498 10.4167 5.158C10.2625 5.26101 10.1423 5.40743 10.0714 5.57873C10.0004 5.75004 9.98184 5.93854 10.018 6.1204C10.0542 6.30225 10.1435 6.4693 10.2746 6.60041C10.4057 6.73152 10.5727 6.82081 10.7546 6.85699C10.9365 6.89316 11.125 6.87459 11.2963 6.80364C11.4676 6.73268 11.614 6.61252 11.717 6.45835C11.82 6.30418 11.875 6.12292 11.875 5.9375C11.875 5.68886 11.7762 5.4504 11.6004 5.27459C11.4246 5.09877 11.1861 5 10.9375 5Z"
                  fill="#50616F"
                />
                <path
                  d="M10.9375 18.75C9.20692 18.75 7.51519 18.2368 6.07626 17.2754C4.63733 16.3139 3.51582 14.9473 2.85356 13.3485C2.19129 11.7496 2.01801 9.9903 2.35563 8.29296C2.69325 6.59563 3.52661 5.03653 4.75032 3.81282C5.97403 2.58911 7.53313 1.75575 9.23046 1.41813C10.9278 1.08051 12.6871 1.25379 14.286 1.91606C15.8848 2.57832 17.2514 3.69983 18.2129 5.13876C19.1743 6.57769 19.6875 8.26942 19.6875 10C19.6875 12.3206 18.7656 14.5462 17.1247 16.1872C15.4837 17.8281 13.2581 18.75 10.9375 18.75ZM10.9375 2.5C9.45414 2.5 8.0041 2.93987 6.77073 3.76398C5.53736 4.58809 4.57606 5.75943 4.00841 7.12988C3.44075 8.50032 3.29223 10.0083 3.58161 11.4632C3.871 12.918 4.58531 14.2544 5.6342 15.3033C6.6831 16.3522 8.01947 17.0665 9.47433 17.3559C10.9292 17.6453 12.4372 17.4968 13.8076 16.9291C15.1781 16.3614 16.3494 15.4001 17.1735 14.1668C17.9976 12.9334 18.4375 11.4834 18.4375 10C18.4375 8.01088 17.6473 6.10323 16.2408 4.6967C14.8343 3.29018 12.9266 2.5 10.9375 2.5Z"
                  fill="#50616F"
                />
              </svg>
            </template>
            <template #title>
              Удобнее и быстрее оформить в личном кабинете
            </template>
          </CalcComment>
          <div class="d-flex align-center justify-content-between">
            <a
              class="calculator__button calculator__button_back-step me-2 calculator__button_back-step_full"
              :class="{'calculator__button_loading': isLoading}"
              @click="onRestart"
            >
              <span>
                Оформить еще
              </span>
            </a>
            <a
              class="calculator__button calculator__button_to-lk"
              :href="`https://lk.boxberry.ru/${UTMTags}`"
              rel="noopener"
            >В&nbsp;личный кабинет</a>
          </div>
        </div>
      </template>
    </CalcNavMobile>
  </div>
</template>

<script>
import CalcNavDesktop from './components/CalcNavDesktop.vue';
import CalcNavMobile from './components/CalcNavMobile.vue';
import deviceInfo from '../../helpers/device';
import SlickGallery from '../SlickGallery/SlickGallery.vue';
import CalculatorSelectedOdp from '../CalculatorMap/CalculatorSelectedOdp.vue';
import { COUNTRY_CODES, DELIVERY_TYPES, MOBILE_STORES } from '../../helpers/constans';
import UTMTags from '../../mixins/UTMTags';
// import { proxyPipPaymentInit } from '../../models/calculator-pip';
import CalcComment from './components/CalcComment.vue';
import CalcCommentError from './components/CalcCommentError.vue';
import GiftCalcCard from '../GiftCard/GiftCalcCard.vue';

const _ = require('lodash');

export default {
  name: 'CalculatorPIP6thStepView',
  components: {
    GiftCalcCard,
    SlickGallery,
    CalcNavMobile,
    CalcNavDesktop,
    CalcCommentError,
    CalcComment,
    CalculatorSelectedOdp,
  },
  mixins: [UTMTags],
  props: ['orderPIP', 'orderCalcPIP', 'senderPointsCollection', 'order_num', 'validations', 'emailPayment', 'order', 'errorDictionary', 'senderPointPayment', 'resultPage'],
  data() {
    return {
      isLoading: false,
      resultPageSuccess: false,
      resultPageFail: false,
      resultFailText: '',
    };
  },
  computed: {
    MOBILE_STORES() {
      return MOBILE_STORES;
    },
    ...deviceInfo,
    selectedSenderODP() {
      if (this.senderPointPayment) return this.senderPointPayment;
      return _.find(this.senderPointsCollection, { id: this.orderPIP.sender.point });
    },
    isCourierFence() {
      return this.orderPIP.delivery_type === DELIVERY_TYPES.DOOR_TO_PVZ
        || this.orderPIP.delivery_type === DELIVERY_TYPES.DOOR_TO_DOOR;
    },
    getAddress() {
      if (this.orderPIP.sender.country === COUNTRY_CODES.ARMENIA) {
        return this.selectedSenderODP.address.substr(6);
      }
      return this.selectedSenderODP.address.substr(7);
    },
    isPaymentRfRf() {
      // TODO временно
      return this.orderPIP.sender.country === 'test' && (this.orderPIP.sender.country === COUNTRY_CODES.RUSSIA
        && this.orderPIP.receiver.country === COUNTRY_CODES.RUSSIA
        && this.order.price > 0
        && this.order.payerType === 1);
    },
  },
  created() {
    this.sharesEnabled = typeof navigator.share === 'undefined';
  },
  beforeMount() {
    if (this.resultPage) {
      if (window.location.pathname.indexOf('success') === 1) {
        this.resultPageSuccess = true;
      }
      if (window.location.pathname.indexOf('fail') === 1) {
        this.resultPageFail = true;
        const params = new URLSearchParams(window.location.search);
        if (params.has('error_description')) {
          this.resultFailText = params.get('error_description');
        }
      }
    }
  },
  methods: {
    mobileReply() {
      if (navigator.share) {
        navigator.share({
          title: `${this.$t('nomer-otpravleniya')} ${this.order_num}`,
          url: window.location.href,
        });
      }

      throw new Error('Web Share API не поддерживается');
    },
    onRestart() {
      this.isLoading = true;
      this.$emit('restart', 'withScroll');
    },
    onPaymentClick() {
      const fieldsValidate = this.validations.emailPayment.validFormat && this.validations.emailPayment.required;
      if (fieldsValidate) {
        this.paymentHandler();
      } else {
        this.$emit('someAction');
      }
    },
    paymentHandler() {
      this.isLoading = true;
      // proxyPipPaymentInit(this.order_num, this.emailPayment, this.order.price, this.order.payerType, this.errorDictionary, this.orderPIP.sender.point, this.orderPIP.delivery_type)
      //   .then((data) => {
      //     if (!data?.data?.paymentUrl) {
      //       throw new Error('Нет ссылки на платёжный кабинет');
      //     } else {
      //       window.location = data.data.paymentUrl;
      //     }
      //   })
      //   .catch((errArr) => {
      //     this.$emit('error', errArr.message);
      //   })
      //   .finally(() => {
      //     this.isLoading = false;
      //   });
    },
    copyToClipboard() {
      window.navigator.clipboard.writeText(this.order_num);
    },
  },
};
</script>

<style lang="scss" scoped>
.calc-6th__odp-desc__list {
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #50616F;
    &:not(:last-of-type) {
      margin-bottom: 8px;
    }
    svg {
      margin-right: 8px;
      color: #9FB3C3;
    }
  }
}
.calc-6th__gallery {
  margin-top: 16px;
  position: relative;
}
.calculator__cols {
  margin-bottom: 0 !important;
}
.calc-6th__text {
  margin-bottom: 24px;
  font-size: 14px;
  font-weight: 400;
  color: #50616F;
}
.calc-6th__mobile-app-links {
  position: relative;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    right: -37px;
    width: 391px;
    height: 305px;
    background: url('https://storage.yandexcloud.net/boxberrysite-public/mobile_app/iphone.png') no-repeat right bottom;
    background-size: contain;
    pointer-events: none;
    @media (max-width: 1200px) {
      right: 0;
      background-image: url('https://storage.yandexcloud.net/boxberrysite-public/mobile_app/iphone-md.png');
    }
    @media (max-width: 767px) {
      top: -20px;
      right: 0;
      width: 127px;
      height: 127px;
      background-image: url('https://storage.yandexcloud.net/boxberrysite-public/mobile_app/iphone-sm.png');
    }
  }
  .mobile-app-links__title {
    font-size: 24px;
    font-weight: 600;
    line-height: 29px;
    color: #333333;
    @media (max-width: 767px) {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      span {
        font-weight: 700;
      }
    }
  }
  .mobile-app-links__items {
    margin-bottom: 20px;
    @media (max-width: 767px) {
      margin-bottom: 0;
      justify-content: flex-start;
    }
  }
  .mobile-app-links__item {
    @media (max-width: 767px) {
      margin-right: 4px;
    }
  }
  .mobile-app-links__item__link {
    @media (max-width: 767px) {
      width: 108px;
      height: 32px;
    }
  }
  .mobile-app-links__item__link_gallery {
    @media (max-width: 767px) {
      width: 33px;
    }
  }
}
.calc-6th__mobile-app-links__inner {
  padding: 32px;
  background-color: #fff;
  border-radius: 20px;
  @media (max-width: 767px) {
    padding: 12px;
  }
}
.calculator__cols_courier {
  margin-bottom: 40px !important;
}
.calculator__button_back-step.calculator__button_back-step_full {
  width: auto !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.calculator__col_order-num {
  @media (max-width: 767px) {
    order: -1;
  }
}
.field-input__inner.field-input__inner_order-num {
  font-size: 20px !important;
  font-weight: 600 !important;
  line-height: 26px !important;
}
.calc-6th__gift-card {
  margin-top: 24px;
  @media (max-width: 767px) {
    margin-top: 0;
  }
}
.calc-6th__gift-card-wrap {
  padding: 18px 0 19px 0;
  margin: 0 -16px -16px -16px;
  flex-grow: 1;
  background: #fff;
}
.calc-6th__calculator-map-preview#calculatorMapPreview {
  @media (max-width: 767px) {
    margin-bottom: 0;
  }
}
</style>
<style lang="scss">
.calc-6th__gallery .item-carousel.slick-slider,
.calc-6th__gallery .slick-list {
  height: 300px;
}
#calculatorMapPreview {
  border-radius: 6.38px;
  overflow: hidden;
}
.calc-6th__comment {
  margin-left: auto;
  margin-right: 24px;
}
.calc-6th__nav-mobile__content {
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>
